import { render } from "./SidebarMenuLabel.vue?vue&type=template&id=330644c8&scoped=true"
import script from "./SidebarMenuLabel.vue?vue&type=script&lang=js"
export * from "./SidebarMenuLabel.vue?vue&type=script&lang=js"

import "./SidebarMenuLabel.vue?vue&type=style&index=0&id=330644c8&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330644c8"]])

export default __exports__